var App = App || {};

App.AwardsBand = (function ($) {
    "use strict";

    function init() {

        const awardsBands = $(".block.block-awardsband");
        if (awardsBands.length) {
            awardsBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(awardsBand) {
        const carousel = awardsBand.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                fixedWidth: "206px",
                gap: "12px",
                drag: true,
                snap: false,
                perMove: 1
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.AwardsBand.init();
});